module.exports = require('./helpers/bundle-url').getBundleURL('81jXc') + "logo-dark.eefe0b7f.svg";